import React, { useEffect } from 'react'
import { Pressable, View, ViewStyle } from 'react-native'

import {
  useNormalize,
  Text,
  useTranslate,
  useTheme,
  base_color,
} from '@unboared/base-ui.all'

import { useMargin, GoogleSignIn } from '../signin'
import { EmailPasswordSignUp } from './components/email_password'
import { useAuth } from '../../../services/auth'
import { ActivityIndicator } from '../../../components/loaders'
import { useLinkTo } from '@react-navigation/native'
import HomeContainer from '../../../components/container/home_container'
import { GoogleSignUp } from '../signin/components/google'
import { useAnalyticsAccessEvent } from '../../../services/analytics'

/**
 * Sign in page.
 */
export const SignUp = ({ onHome, onLogin, onSuccessSignUp }: any) => {
  useAnalyticsAccessEvent('singup')

  const loading = useAuth((state) => state.loading)

  const styles = {
    container: {
      flexDirection: 'row',
    } as ViewStyle,
    flexCenter: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    } as ViewStyle,
    content: {
      minWidth: '80%',
      maxWidth: '80%',
      justifyContent: 'center',
    } as ViewStyle,
  }

  return (
    <HomeContainer onHome={onHome}>
      <View style={[styles.flexCenter, styles.container]}>
        <View style={styles.flexCenter}>
          {loading ? (
            <ActivityIndicator />
          ) : (
            <View style={styles.content}>
              <EmailPasswordSignUp onSuccessSignUp={onSuccessSignUp} />
              <SignUpSeparator />
              <GoogleSignUp onSuccessSignUp={onSuccessSignUp} />
              <CreateAccount goToLogin={onLogin} />
            </View>
          )}
        </View>
      </View>
    </HomeContainer>
  )
}

const CreateAccount = ({ goToLogin }: any) => {
  const { translate } = useTranslate()
  const { largeMargin } = useMargin()

  const theme = useTheme()

  const linkTo = useLinkTo()
  const resetFields = useAuth((state) => state.resetFields)

  return (
    <Pressable
      onPress={() => {
        resetFields()
        if (goToLogin) {
          goToLogin()
        } else {
          linkTo('/login')
        }
      }}
    >
      <Text
        style={{
          ...largeMargin,
          fontFamily: 'OpenSansBold',
          alignSelf: 'center',
        }}
      >
        {translate('common.signup.alreadyAccount.message')}{' '}
        <Text
          style={{
            color: theme.color.primary,
            fontFamily: 'OpenSansBold',
          }}
          tx="common.signup.alreadyAccount.login"
        />
      </Text>
    </Pressable>
  )
}

const SignUpSeparator = () => {
  const theme = useTheme()
  const { normalize } = useNormalize()
  const { smallMargin } = useMargin()

  return (
    <Text
      tx="common.signin.or"
      style={{
        ...smallMargin,
        color: base_color.light_secondary,
        alignSelf: 'center',
        fontFamily: 'OpenSansBold',
      }}
    />
  )
}

export default SignUp
